// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p1_L","controls":"styles_controls__3tWz4","charLimit":"styles_charLimit__9XE06","input":"styles_input__3HRce","send":"styles_send__2628c"};